// Considered: none — no prior/new inline value primitive exists. See spec Reuse Audit
// (specs/stream-trajectory-tools.md § Design System Reuse Audit — "New components — justified").
//
// Source: design/metaspace-tools/metaspace-tools-v2.jsx:168-176. Renders the delta run for an
// `aspect_observation` chord: strikethrough prior -> arrow-right glyph -> 800-weight new value,
// mono throughout, with an optional qualifier (e.g. a choice-aspect's bucket label).

import React from 'react';
import GlyphAtom from '../Glyph/GlyphAtom';
import './DeltaRunAtom.scss';

export interface DeltaRunAtomProps {
  /** The value before this observation. Omit when there is no prior value to show. */
  previous?: string | null;
  /** The value this observation records. */
  next: string;
  /** e.g. a choice bucket label ("Minimal") rendered after a middle dot. */
  qualifier?: string;
  className?: string;
}

const DeltaRunAtom: React.FC<DeltaRunAtomProps> = ({ previous, next, qualifier, className }) => {
  return (
    <span className={['delta-run-atom', className].filter(Boolean).join(' ')}>
      {previous != null && previous !== '' && (
        <>
          <s className="delta-run-atom__prior">{previous}</s>
          <GlyphAtom glyph="lucide:arrow-right" className="delta-run-atom__arrow" />
        </>
      )}
      <strong className="delta-run-atom__new">{next}</strong>
      {qualifier && (
        <>
          <span className="delta-run-atom__sep">·</span>
          <span className="delta-run-atom__qualifier">{qualifier}</span>
        </>
      )}
    </span>
  );
};

DeltaRunAtom.displayName = 'DeltaRunAtom';

export default DeltaRunAtom;
